import { render, staticRenderFns } from "./employeeType.vue?vue&type=template&id=18f9e6d4&"
import script from "./employeeType.vue?vue&type=script&lang=js&"
export * from "./employeeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports